import React from "react";

export default (props) => {
  if (props.hide) {
    return <React.Fragment />;
  }

  return <div {...props} className={`row ${props.className} ${props.py ? `py-${props.py}`: ''}  `}>{props.children}</div>;
};



// WEBPACK FOOTER //
// ./src/_components/Layout/Row/index.jsx